import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toDate } from "../../../utils/toDate";

import classes from "../../../components/Modal.module.css";

import printIcon from "../../../assets/printer_icon.png";
import editIcon from "../../../assets/edit_icon.png";

import CustomButton from "../../../components/CustomButton";
import Modal from "../../../components/Modal";
import SectionDivider from "../../../components/SectionDivider";
import InformationBox from "../../../components/InformationBox";
import InformationDiv from "../../merchant-pages/invoicesOfMulti/InformationDiv";
import { getInvoiceById } from "../../../services/invoices/multiContainerWithoutC";

export default function NoCustomerInformationModal({ handleClose, invoiceId }) {
  const { t } = useTranslation("general");

  const [invoiceData, setInvoiceData] = useState({});

  const printRef = useRef(null);

  const getInvoiceData = async () => {
    try {
      const response = await getInvoiceById(invoiceId);

      if (response.status === 200) {
        setInvoiceData(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (invoiceId) {
      getInvoiceData();
    }
  }, [invoiceId]);

  const handlePrint = () => window.print();

  return (
    <Modal
      title={t("invoiceDetails")}
      onClose={handleClose}
      footer={
        <section className={classes.actions}>
          {invoiceData.invoiceNumber ? null : (
            <CustomButton
              variant="blank"
              elementType={Link}
              title={t("edit")}
              to={`/editContainer/${invoiceData?.id}`}
              // onClick={handleEdit}
              state={invoiceData}
              icon={editIcon}
              iconSize={18}
            />
          )}
          <CustomButton
            title={t("print")}
            variant="gray"
            icon={printIcon}
            iconSize={18}
            onClick={handlePrint}
          />
        </section>
      }
    >
      <div className="printing-area" ref={printRef}>
        <InformationDiv title="supplier" value={invoiceData?.supplier?.name} />

        <InformationDiv
          title="invoiceNumber"
          value={invoiceData?.invoiceNumber}
        />

        <InformationDiv
          title="amountForSupplier"
          value={invoiceData?.amountForSupplier}
        />

        <InformationDiv title="Date" value={toDate(invoiceData?.date)} />

        <InformationDiv title="company" value={invoiceData?.subCompany?.name} />

        <InformationDiv title="createdBy" value={invoiceData?.user?.username} />

        {/* Containers info */}
        {invoiceData?.ShippedContainer?.length ? (
          <>
            <SectionDivider title="containersDetails" />
            {invoiceData?.ShippedContainer?.map((container, index, array) => (
              <>
                {/* Add a title for every container, if there are multiple */}
                {array?.length > 1 && (
                  <p className="bold-text">
                    {t("container")} {index + 1}:
                  </p>
                )}

                <InformationDiv
                  title="containerNumber"
                  value={container?.containerNumber}
                  key={index}
                />
                <InformationDiv
                  title="expectedArrivalDate"
                  value={toDate(container?.expectedArrivalDate)}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="finalDestination"
                  value={container?.finalDestination}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="material"
                  value={container?.material}
                  key={index}
                  classList="ignore-in-print"
                />
                <div className="o-row">
                  <InformationDiv
                    title="numberOfBoxes"
                    value={container?.numberOfBoxes}
                    key={index}
                    classList="ignore-in-print"
                  />

                  <InformationDiv
                    title="measuringUnit"
                    value={container?.measuringUnit}
                    key={index}
                    classList="ignore-in-print"
                  />
                </div>
                {/* <InformationDiv
                  title="unitPrice"
                  value={container?.unitPrice}
                  key={index}
                  classList="ignore-in-print"
                /> */}
                <InformationDiv
                  title="shipper"
                  value={container?.shipper}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="shippingDate"
                  value={toDate(container?.shippingDate)}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="subCompany"
                  value={invoiceData?.subCompany?.name}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="exitDate"
                  value={toDate(container?.exitDate)}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="dateOfEntry"
                  value={toDate(container?.dateOfEntry)}
                  key={index}
                  classList="ignore-in-print"
                />

                <InformationDiv
                  title="permitsReceivingDate"
                  value={toDate(container?.permitsReceivingDate)}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="notes"
                  value={container?.notes}
                  key={index}
                  classList="ignore-in-print"
                />

                {/* Add a rule for all containers, except the last one */}
                {array.length - 1 > index && (
                  <div className="horizontal-rule"></div>
                )}
              </>
            ))}
          </>
        ) : (
          <InformationBox>{t("noContainers")}</InformationBox>
        )}
      </div>
    </Modal>
  );
}
